module.exports = __webpack_public_path__ + "static/media/amex.eb25866a.png";